export default __webpack_public_path__ + "static/media/m_ie.551c37dc.svg";